import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useGetPayoutInfo from '../../../hooks/site/finance/useGetPayoutInfo';
import { API_FINANCE } from '../../../api/finance';
import PayoutPlayersTable from './PayoutPlayersTable';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import PaymentFilter from './PaymentFilter';
import { useAppSelector } from '../../../store';
import { useDispatch } from 'react-redux';
import { setPayoutFilter, setPayoutInfo } from '../../../store/apps/financeSlice';
import { ENUM_CURRENCY } from '../../../components/shared/CurrencySelect';
import { postOptions, TEST_MODE } from '../../../enums/enums';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import DefaultPagination from '../../../components/material-ui/pagination/DefaultPagination';
import { mockOutputs } from '../../../enums/mock';

export default function PaymentPlayers() {
  const { statusHash, updatePlayers, updateGates } = useGetPayoutInfo();
  const dispatch = useDispatch();
  const payoutInfo = useAppSelector((state) => state.finance.payout.info);
  const filter = useAppSelector((state) => state.finance.payout.filter);

  const [pageNo, setPageNo] = useState(payoutInfo.pageNo || 1);
  const [pageSize, setPageSize] = useState(payoutInfo.pageSize || postOptions[0].value);
  const [pageCount, setPageCount] = useState(payoutInfo.pageCount || null);

  const [btnLoading, setBtnLoading] = useState(false);
  const [alreadyShow, setAlreadyShow] = useState(false);

  const payouts = payoutInfo.list;
  const filterPage = filter.pageNo;

  useEffect(() => {
    if (!filterPage) return;
    setPageNo(filterPage);
  }, [filterPage]);

  const onSaveClick = (newPayload) => {
    setBtnLoading(true);
    setAlreadyShow(true);

    const payload = { pageNo, pageSize, ...filter, ...newPayload };
    // если есть изменения
    if (
      payload.groupId !== filter.groupId ||
      payload.userId !== filter.userId ||
      payload.dateFrom !== filter.dateFrom ||
      payload.dateTo !== filter.dateTo ||
      payload.status !== filter.status ||
      payload.source !== filter.source ||
      payload.currency !== filter.currency
    ) {
      payload.pageNo = 1;
    }

    const curPayload = { ...payload };
    if (curPayload.currency == ENUM_CURRENCY.all) curPayload.currency = null;

    API_FINANCE.payout
      .list(curPayload)
      .then((e) => {
        const data = e.data.data;
        dispatch(setPayoutFilter(payload));
        dispatch(setPayoutInfo({ reactId: Math.random(), ...data }));
        setPageNo(data.pageNo);
        setPageCount(data.pageCount);
      })
      .catch(console.log)
      .finally(() => setBtnLoading(false));
  };

  useEffect(() => {
    if (!TEST_MODE) return;
    dispatch(setPayoutInfo({ reactId: Math.random(), ...mockOutputs }));
  }, [TEST_MODE]);

  return (
    <CusPageCardContainer title="Payments to players">
      <Stack display={'flex'} direction={'column'} gap={3}>
        <PaymentFilter
          statusHash={statusHash}
          btnLoading={btnLoading}
          onSaveClick={onSaveClick}
          updatePlayers={updatePlayers}
          setPageNo={setPageNo}
        />

        <PayoutPlayersTable
          updateGates={updateGates}
          payoutInfo={payoutInfo}
          statusHash={statusHash}
          alreadyShow={alreadyShow}
          btnLoading={btnLoading}
          startPageNumber={pageNo * pageSize - pageSize + 1}
        />

        {/* <ShowContainer condition={payouts?.length}> */}
        <DefaultPagination
          curPage={pageNo}
          pageCount={pageCount}
          selectRecord={pageSize}
          setCurPage={setPageNo}
          setSelectRecord={setPageSize}
          onFindClick={onSaveClick}
        />
        {/* </ShowContainer> */}
      </Stack>
    </CusPageCardContainer>
  );
}
